/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"

const Layout = ({ children, podcast }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} podcast={podcast} />
      <div
        style={{
          margin: `0 auto`,
          // maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
        className="max-w-6xl"
      >
        <main>{children}</main>
        <footer className="m-auto mt-10 mb-6 text-center text-sm tracking-wide">
          Copyright © {new Date().getFullYear()} Donald Miller Words, LLC. All
          rights reserved.{" "}
          <a
            className="text-baseBlue tracking-wide mr-2"
            href="tel:615-915-1541"
          >
            615-915-1541
          </a>
          {"  "}
          <a
            href="https://businessmadesimple.com/terms-and-conditions/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-baseBlue text-sm"
          >
            Terms and Conditions / Privacy Policy
          </a>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
